import { z } from "zod";

import {
  egressLightSchema,
  fireDrillSchema,
  fireExtinguisherSchema,
  smokeDetectorSchema,
} from "../../../schemas";

export const monthlyBehavioralHealthFireDrillSchema = z
  .object({
    ...fireDrillSchema.shape,
    firstaidExpired: z.string(),
    sprinklerChecked: z.string().trim().min(1, "Required"),
    sprinklerClearance: z.string().trim().min(1, "Required"),
    sprinklerIssues: z.string().trim().min(1, "Required"),
    sprinklerIssueDescription: z.string().optional(),
    sprinklerHeadsStorage: z.string().min(1, "Required"),
    smokeDetectors: z.array(smokeDetectorSchema).optional(),
    extinguishers: z.array(fireExtinguisherSchema).optional(),
    egressLights: z.array(egressLightSchema).optional(),
  })
  .superRefine(
    ({ sprinklerIssues, sprinklerIssueDescription }, refinementContext) => {
      if (sprinklerIssues === "No") {
        if (
          sprinklerIssueDescription === undefined ||
          sprinklerIssueDescription.trim() === ""
        ) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Required",
            path: ["sprinklerIssueDescription"],
          });
        }
      }
    },
  );

export const fireDrillCreateSchema =
  monthlyBehavioralHealthFireDrillSchema.superRefine(
    ({ auditDate }, refinementContext) => {
      const date = new Date();
      if (date > new Date(date.getFullYear(), date.getMonth(), 5)) {
        if (auditDate < new Date(date.getFullYear(), date.getMonth(), 1)) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Date not in submission window",
            path: ["auditDate"],
          });
        }
      } else {
        if (auditDate < new Date(date.getFullYear(), date.getMonth() - 1, 1)) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Date not in submission window",
            path: ["auditDate"],
          });
        }
      }
    },
  );
export const fireDrillEditSchema = monthlyBehavioralHealthFireDrillSchema;
